import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import ChainOption from "areas/product/jewlr/wizard-options/chain-options"
import { addToCart, forcePanelIndex } from "areas/product/store/actions"
import {
  StyledButton,
  ButtonWrapper,
} from "components/HalfModal/hm-styled-components"
import Modal, { closeModal } from "components/modal"

const ChainSizeModal = ({
  chainSelectorUI,
  addToCart,
  forcePanelIndex,
  selectedValue,
  wizardData,
  pref,
}) => {
  const title =
    wizardData[pref].heading && wizardData[pref].heading.title
      ? `Choose Your ${wizardData[pref].heading.title}`
      : "Choose Your Chain"

  return (
    <Modal
      contentStyle={{ px: { _: 2, tablet: 3 } }}
      headerStyle={{ mb: { _: "10px", tablet: 0 } }}
      height={chainSelectorUI ? "100%" : "fit-content"}
      label={title}
      labelStyle={{ mt: { _: 0, tablet: 0 } }}
      onClose={() => {
        forcePanelIndex(pref)
        closeModal()
      }}
      show={`#chain-size${pref === "ch" ? "" : pref.match(/\d+/)[0]}`}
      variant="squircle"
      width="760px"
    >
      <ChainOption inModal pref={pref} />
      <Box bg="#e3352a26" display="inline-block" px={2} py={1}>
        <Typography color="sale" fontWeight="600" variant="body-xs">
          Please Select Your Chain Length Above
        </Typography>
      </Box>
      <ButtonWrapper mt={{ _: 2, tablet: "20px" }}>
        <StyledButton
          data-cy="product-wizard-ch-modal-continue"
          disabled={selectedValue === ""}
          onClick={(e) => {
            if (selectedValue !== "") {
              addToCart(e)
            }
          }}
          variant="primary"
        >
          Continue
        </StyledButton>
      </ButtonWrapper>
    </Modal>
  )
}

ChainSizeModal.propTypes = {
  addToCart: PropTypes.func,
  chainSelectorUI: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  forcePanelIndex: PropTypes.func,
  pref: PropTypes.string,
  selectedValue: PropTypes.string,
  wizardData: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
  const { pref } = ownProps
  return {
    chainSelectorUI:
      state.wizard.data && state.wizard.data[pref]
        ? state.wizard.data[pref].chain_type_ui
        : false,
    selectedValue: state.choices[pref] ? state.choices[pref].value || "" : "",
    wizardData: state.wizard.data,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (e) => {
      e.preventDefault()
      dispatch(addToCart())
    },
    forcePanelIndex: (pref) => {
      dispatch(forcePanelIndex(pref))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChainSizeModal)
